// Function to push a generic click event to GTM dataLayer
export const trackClickEvent = (
  event_name,
  event_details = null,
  page_category = null,
  client_id = null,
  user_id = null,
  user_status = 'guest',
) => {
  if (typeof dataLayer !== 'undefined') {
    const pageInfo = getPageInfo(document.location.href);
    page_category = pageInfo.pageCategory;
    var searchEventName = 'page_view';
    if (
      dataLayer.some(function (item) {
        return item.event === searchEventName;
      })
    ) {
      var eventData = dataLayer.filter(function (item) {
        return item.event === searchEventName;
      });
      var shopify = eventData[0].payload.shopify;
      client_id = null;
      user_id = shopify.userId;
      user_status = shopify.isLoggedIn ? 'logged_in' : 'guest';
    }

    const eventObject = {
      event: event_name,
      page_category,
      client_id,
      user_id,
      user_status,
      pageTitle: document.title,
      pageLocation: document.location.href,
    };
    var targetElement, classes, textContent;

    switch (event_name) {
      case 'begin_checkout':
        eventObject.userId = eventObject.user_id;
        delete eventObject.user_id;
        eventObject.user_type = eventObject.userId
          ? 'existing_user'
          : 'new_user';
        eventObject.customer_type = eventObject.userId
          ? 'existing_customer'
          : 'new_customer';

        eventObject.ecommerce = {
          currency: event_details?.cost?.subtotalAmount?.currencyCode ?? 'NA',
          value: event_details?.cost?.subtotalAmount?.amount ?? 'NA',
          coupon: 'NA',
          items: event_details?.lines.map((line, index) => {
            var item_id = line.merchandise.id.split('/').pop();
            var item_list_name =
              getStoredItemListName(item_id) ?? getItemListName();

            var item_list_id = generateItemListId(item_list_name);
            return {
              item_id: line.merchandise.product.id.split('/').pop(),
              item_name: line.merchandise.product.title,
              coupon: 'NA',
              currency:
                event_details?.cost?.subtotalAmount?.currencyCode ?? 'NA',
              discount: 0,
              item_category: line?.merchandise?.product?.productType ?? 'NA',
              item_category2: 'NA',
              item_category3: 'NA',
              item_variant:
                line?.merchandise?.selectedOptions?.[0]?.value ?? 'NA',
              price: line.merchandise.priceV2.amount,
              item_list_name,
              item_list_id,
              index,
              quantity: line.quantity,
              item_brand: line?.merchandise?.product?.vendor ?? 'NA',
            };
          }),
        };

        break;
      case 'top_navigation_hook_click':
        targetElement = event_details.target;
        classes = targetElement.parentElement.classList;
        textContent = targetElement.textContent;
        var ctaText = '';
        if (textContent !== '') {
          ctaText = textContent;
        } else {
          if (classes.contains('profile')) {
            ctaText = 'Profile';
          } else {
            ctaText = 'Cart';
          }
        }
        eventObject.cta_text = ctaText;
        break;
      case 'gathr_brand_click':
        var parentAnchor = event_details.target.parentNode;
        var url = parentAnchor.getAttribute('href');
        var brand_name = event_details.target.textContent;
        eventObject.brand_name = brand_name;
        eventObject.url = url;
        break;
      case 'search_click':
        eventObject.search_term = event_details.search_term;
        break;
      case 'footer_navigation_click':
        eventObject.header_title = event_details.header_title;
        eventObject.link_url = event_details.link_url;
        eventObject.cta_text = event_details.cta_text;
        break;
      case 'social_icon_interaction':
        eventObject.social_platform = event_details.social_platform;
        eventObject.link_url = event_details.linkUrl;
        eventObject.cta_text = event_details.ctaText;
        if (!eventObject.cta_text || eventObject.cta_text.trim() === '') {
          eventObject.cta_text = event_details.social_platform + ' Icon';
        }
        break;
      case 'scroll_tracking':
        eventObject.scroll_percentage = event_details.scroll_percentage;
        break;
      case 'consent_popup_interaction':
        switch (event_details.target.id) {
          case 'notificationManagerLink':
            eventObject.cta_text = 'manage_cookies';
            break;
          case 'cookie-notification__accept':
          case 'accept-modal':
          case 'confirm-modal':
            eventObject.cta_text = 'accept';
            break;
          case 'cookie-notification__decline':
          case 'reject-modal':
            eventObject.cta_text = 'decline';
            break;
          case 'close-notification':
            eventObject.cta_text = 'close';
            break;
        }
        break;
      case 'video_interaction':
        eventObject.video_title = event_details.video_title;
        eventObject.video_status = event_details.video_status;
        eventObject.video_percentage = event_details.video_percentage;
        break;
      case 'button_click':
        eventObject.header_title = event_details.header_title;
        eventObject.cta_text = event_details.cta_text;
        break;
      case 'login_initiate':
        eventObject.page_category = 'Login page';
        eventObject.cta_text = event_details.target.textContent;
        break;
      case 'login_submitted':
        eventObject.page_category = 'Login page';
        break;
      case 'login_successfull': {
        eventObject.page_category = 'Login page';
        let textContent = '';
        for (let element of event_details.target) {
          if (element.tagName === 'BUTTON' && element.type === 'submit') {
            textContent = element.textContent;
          }
        }
        eventObject.cta_text = textContent;
        eventObject.user_status = 'logged_in';
        break;
      }
      case 'register_initiate':
        eventObject.page_category = 'Sign up page';
        eventObject.cta_text = event_details.target.textContent;
        break;
      case 'register_successfull': {
        eventObject.page_category = 'Sign up page';
        let textContent = '';
        for (let element of event_details.target) {
          if (element.tagName === 'BUTTON' && element.type === 'submit') {
            textContent = element.textContent;
          }
        }
        eventObject.cta_text = textContent;
        break;
      }
      case 'top_navigation_click':
        eventObject.main_category = event_details.main_category;
        eventObject.sub_category = event_details.sub_category;
        break;
      case 'popup_banner_view':
        eventObject.banner_name = event_details.banner_name;
        break;
      case 'popup_banner_close':
        eventObject.banner_name = event_details.banner_name;
        eventObject.cta_click = event_details.cta_click;
        break;
      case 'popup_banner_cta_click':
        eventObject.banner_name = event_details.banner_name;
        eventObject.cta_click = event_details.cta_click;
        break;
      case 'change_location_click':
        eventObject.selected_location_parameter =
          event_details.selected_location;
        eventObject.cta_text = event_details.cta_text;
        break;
      case 'select_item':
        eventObject.userId = eventObject.user_id;
        delete eventObject.user_id;
        eventObject.user_type = shopify.userId ? 'existing_user' : 'new_user';
        eventObject.user_status = shopify.isLoggedIn ? 'loggedin' : 'guest';
        eventObject.customer_type = shopify.userId
          ? 'existing_customer'
          : 'new_customer';

        var item_id =
          event_details?.product?.variantOverride?.store?.id ??
          event_details?.product?.store?.variants[0]?.store?.id;

        var item_list_name = getItemListName(event_details.e.target);
        var item_list_id = item_list_name.toLowerCase().replace(/\W/g, '-');
        // Retrieve existing item_list_names from localStorage
        var existingItemLists = JSON.parse(
          localStorage.getItem('item_list_names') || '{}',
        );

        // Update with new item_id, item_list_id, and item_list_name
        existingItemLists[item_id] = {item_list_name, item_list_id};

        // Save updated item_list_names back to localStorage
        localStorage.setItem(
          'item_list_names',
          JSON.stringify(existingItemLists),
        );

        eventObject.ecommerce = {
          currency: shopify.currency,
          value: event_details.product.price,
          item_list_name,
          item_list_id,
          items: [
            {
              item_id: item_id,
              item_name: event_details?.product?.matchingShopifyProduct?.title, // Use Shopify variable for product name
              coupon: 'NA', // Use Shopify variable for applied coupon
              currency: shopify.currency, // Use Shopify variable for currency
              discount: 0,
              item_category: event_details?.product?.store?.productType, // Use Shopify variable for product main category
              item_category2:
                event_details?.product?.matchingShopifyProduct?.collections
                  ?.nodes[0]?.title ?? 'NA', // Use Shopify variable for product main category
              item_category3:
                event_details?.product?.matchingShopifyProduct?.collections
                  ?.nodes?.[1]?.title ?? 'NA', // Use Shopify variable for product sub category1
              item_variant:
                event_details?.product?.store?.variants[0].store?.title ?? 'NA',
              price: event_details?.product.store.priceRange.maxVariantPrice,
              item_list_name,
              item_list_id,
              item_brand: event_details?.product?.store?.vendor ?? 'NA',
              index: 1, // Use Shopify variable for the position of the product displayed
              quantity: 1, // Assuming quantity is always 1 for a view_item event
            },
          ],
        };
        eventObject.ecommerce.items[0].index = event_details.index + 1;
        break;
      case 'select_promotion':
        eventObject.userId = eventObject.user_id;
        delete eventObject.user_id;
        eventObject.user_type = shopify.userId ? 'existing_user' : 'new_user';
        eventObject.user_status = shopify.isLoggedIn ? 'loggedin' : 'guest';
        eventObject.customer_type = shopify.userId
          ? 'existing_customer'
          : 'new_customer';
        eventObject.ecommerce = event_details;
        break;
    }

    dataLayer.push(eventObject);
  }
};

function getPageInfo(href) {
  href = href.replace(/\/$/, '').split('/');
  const subdomain = href[2] ? href[2].split('.')[0] : null;
  if (href.length === 3) {
    return {pageCategory: 'Homepage', subdomain};
  }
  if (href.length === 5 && href[3] === 'pages') {
    return {pageCategory: 'Content Page', slug: href[4], subdomain};
  }
  if (href.length === 5 && href[3] === 'collections') {
    return {pageCategory: 'Collection Page', slug: href[4], subdomain};
  }
  if (href.length === 5 && href[3] === 'products') {
    return {pageCategory: 'Product Page', slug: href[4], subdomain};
  }
  return {pageCategory: 'Other', subdomain};
}

function fetchAndFormatMasterDetail() {
  // Initialize an array to hold the formatted strings for each category
  const formattedStrings = [];

  // Find all filter group divs
  const filterGroups = document.querySelectorAll(
    '.searchspring-facet-filters > div',
  );

  filterGroups.forEach((group) => {
    // Extract the category name
    const categoryElement = group.querySelector(
      '.searchspring-facet-filters__heading',
    );
    if (categoryElement) {
      const categoryName = categoryElement.textContent.trim();

      // Extract all options within this category
      const options = group.querySelectorAll(
        '.searchspring-facet-filters__option',
      );
      const optionValues = Array.from(options).map((option) => {
        // Split to remove the count and trim to clean up the string
        return option.textContent.trim().split(' (')[0];
      });

      if (optionValues.length) {
        // Format the string for this category
        const formattedString = `${categoryName} - ${optionValues.join(' | ')}`;
        formattedStrings.push(formattedString);
      }
    }
  });

  // Join all formatted strings for each category
  return formattedStrings.join(' | ');
}

function getItemListName(targetElement) {
  var item_list_name = fetchAndFormatMasterDetail();

  if (!item_list_name) {
    // Prioritize getting "You May Also Like" text from the specific structure
    var moduleTitle = document.querySelector('.page-header h1');
    if (moduleTitle) {
      item_list_name = moduleTitle.textContent.trim();
    } else {
      // Look for sibling h1 or h2 elements
      var siblingHeading =
        targetElement?.previousElementSibling ||
        targetElement?.nextElementSibling;
      while (
        siblingHeading &&
        siblingHeading.tagName !== 'H1' &&
        siblingHeading.tagName !== 'H2'
      ) {
        siblingHeading =
          siblingHeading?.previousElementSibling ||
          siblingHeading?.nextElementSibling;
      }

      // If a sibling h1 or h2 is found, use its text content
      if (
        siblingHeading &&
        (siblingHeading.tagName === 'H1' || siblingHeading.tagName === 'H2')
      ) {
        item_list_name = siblingHeading.textContent.trim();
      } else {
        // If no sibling h1 or h2 is found, then look for descendant h1 or h2
        var h1Descendant = targetElement?.querySelector('h1');
        var h2Descendant = !h1Descendant
          ? targetElement?.querySelector('h2')
          : null;

        if (h1Descendant || h2Descendant) {
          item_list_name = (h1Descendant || h2Descendant).textContent.trim();
        } else {
          // get first h1 or h2
          var firstHeading = document.querySelector('h1, h2');
          if (firstHeading) {
            item_list_name = firstHeading.textContent.trim();
          } else {
            item_list_name = 'NA';
          }
        }
      }
    }
  }
  // if item_list_name has this pattern Your Cart (some number) remove everything in the parenthesis and the parenthesis
  if (item_list_name.includes('(')) {
    item_list_name = item_list_name.replace(/\(.*?\)/g, '').trim();
  }
  item_list_name = item_list_name.substring(0, 100);
  return item_list_name;
}

function generateItemListId(item_list_name) {
  return item_list_name
    .split(' ')
    .join('_')
    .toLowerCase()
    .replace(/[^a-zA-Z0-9]/g, '_');
}
function getStoredItemListName(item_id) {
  // Retrieve existing item_list_names from localStorage
  var existingItemLists = JSON.parse(
    localStorage.getItem('item_list_names') || '{}',
  );

  // Attempt to find a matching item_list_name in localStorage
  const storedItem = existingItemLists[item_id];
  return storedItem ? storedItem.item_list_name : null;
}
